import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from 'generated/graphql';
import { ParagraphSmall } from 'packages/kakapo-ui-kit/components/common/Paragraph';

import TalentReviewProgressPie from './TalentReviewProgressPie';

export default function TalentReviewProgress(props: {
	review: graphql.TalentReview;
	placements: graphql.TalentReviewPlacement[];
}) {
	const { t } = useTranslation();

	const progress = props.placements.length / props.review.group.members.edges.length;

	const size = props.review.template.xAxis.ticks.length * props.review.template.yAxis.ticks.length;

	return (
		<Flex alignItems="center">
			<Box mr={2}>
				<ParagraphSmall color="slateBlue">
					{t('talentReviews.edit.progress.instruction', { size })}
				</ParagraphSmall>
			</Box>
			<Box mr={2} flexGrow={0} flexShrink={0}>
				<TalentReviewProgressPie progress={progress} />
			</Box>
		</Flex>
	);
}
